// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"552":"c68343d9","580":"c68343d9","784":"fd8dbd6e","808":"c40de637"}[chunkId] + ".chunk.css";
};